import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IOperationLogsActivity } from "redux/app/vdmdashboard/@types";
import { IStore } from "redux/store";
import OperationLogsTableRow from "./OperationLogsTableRow";

type OwnProps = {};
type OperationLogsTableProps = PropsFromRedux & OwnProps;
function OperationLogsTable(props: OperationLogsTableProps) {
	const operationLogsTableData: IOperationLogsActivity[] = [
		{
			id: "1",
			activity: "HRA transit",
			region: "MV - Lake Quraoun",
			inTime: "06:00, 12 Jan",
			outTime: "13:00, 12 Jan",
			vendor: "Oceanic Delights",
			reporting: {
				lastReportedAt: "3:45 PM, October 12, 2023",
				reportedBy: "Alex Johnson",
			},
		},
		{
			id: "2",
			activity: "VRA transit",
			region: "MV - Lake Quraoun",
			inTime: "06:00, 12 Jan",
			outTime: "13:00, 12 Jan",
			vendor: "Harbor Bounty",
			reporting: {
				lastReportedAt: "2:30 PM, October 12, 2023",
				reportedBy: "Maria Gonzalez",
			},
		},
		{
			id: "3",
			activity: "Armed Guards",
			details: {
				qty: 10,
			},
			region: "MV - Lake Quraoun",
			inTime: "06:00, 12 Jan",
			outTime: "13:00, 12 Jan",
			vendor: "Coastal Harvest",
			reporting: {
				lastReportedAt: "5:00 PM, October 12, 2023",
				reportedBy: "James Brown",
			},
		},
		{
			id: "4",
			activity: "ASEV",
			details: {
				boatName: "Boat name",
				qty: 10,
			},
			region: "MV - Lake Quraoun",
			inTime: "06:00, 12 Jan",
			outTime: "13:00, 12 Jan",
			vendor: "Nautical Farms",
			reporting: {
				lastReportedAt: "1:00 PM, October 12, 2023",
				reportedBy: "Sarah Lee",
			},
		},
		{
			id: "5",
			activity: "STOW Away Search",
			region: "MV - Lake Quraoun",
			inTime: "06:00, 12 Jan",
			outTime: "13:00, 12 Jan",
			vendor: "Seaside Market",
			reporting: {
				lastReportedAt: "4:15 PM, October 12, 2023",
				reportedBy: "David Smith",
			},
		},
	];

	return (
		<div className="overflow-x-auto border border-b-none border-gray-300 rounded ws-scroll shadow-md mt-4">
			<table className="min-w-full overflow-x-auto divide-y divide-gray-200">
				<thead className="bg-gray-50 text-gray-600">
					<tr>
						<th className="px-3 py-2 text-left text-sm font-medium  whitespace-nowrap">
							Activity
						</th>
						<th className="px-3 py-2 text-left text-sm font-medium  whitespace-nowrap">
							Region
						</th>
						<th className="px-3 py-2 text-left text-sm font-medium whitespace-nowrap">
							In time - Out time
						</th>
						<th className="px-3 py-2 text-left text-sm font-medium whitespace-nowrap">
							Vendor
						</th>
						<th className="px-3 py-2 text-left text-sm font-medium whitespace-nowrap">
							Reporting
						</th>
					</tr>
				</thead>
				<tbody className="bg-white">
					{operationLogsTableData?.map((row, idx) => (
						<OperationLogsTableRow row={row} />
					))}
				</tbody>
			</table>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(OperationLogsTable);
